var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { matchProviderType } from '../../Payment';
import AccordionWidget from '../../../AccordionWidget';
import marked from 'marked';

var PaymentMethodItemHeader = function PaymentMethodItemHeader(_ref) {
  var detail = _ref.detail;
  return React.createElement(
    'div',
    { className: 'payment-method-item-header' },
    detail && detail.image && React.createElement('div', {
      className: 'provider-logo',
      style: {
        backgroundImage: 'url(' + detail.image.file.url + ')'
      }
    }),
    detail && React.createElement(
      'div',
      { className: 'title-text' },
      detail.title
    )
  );
};

var PaymentMethodItemContent = function PaymentMethodItemContent(_ref2) {
  var content = _ref2.content;
  return React.createElement(
    'div',
    { className: 'payment-method-item-content' },
    content
  );
};

var getPaymentDetailByMethod = function getPaymentDetailByMethod(payments, method) {
  return payments.find(function (p) {
    return matchProviderType(p, method);
  }) || {};
};

var PaymentMethodSelector = function (_Component) {
  _inherits(PaymentMethodSelector, _Component);

  function PaymentMethodSelector() {
    _classCallCheck(this, PaymentMethodSelector);

    return _possibleConstructorReturn(this, (PaymentMethodSelector.__proto__ || Object.getPrototypeOf(PaymentMethodSelector)).apply(this, arguments));
  }

  _createClass(PaymentMethodSelector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          methods = _props.methods,
          payments = _props.payments,
          onSelectMethod = _props.onSelectMethod,
          methodContent = _props.methodContent,
          selectedMethod = _props.selectedMethod;

      var selectedMethodIndex = methods.findIndex(function (method) {
        return method.txType === selectedMethod.txType;
      });

      var items = methods.map(function (method, i) {
        var detail = getPaymentDetailByMethod(payments, method);
        return {
          method: method,
          header: React.createElement(PaymentMethodItemHeader, { detail: detail }),
          tooltip: detail.content && marked(detail.content),
          tooltipOpen: detail.showInfo,
          content: React.createElement(PaymentMethodItemContent, { content: methodContent(method) }),
          key: method.txType + i
        };
      });

      return React.createElement(
        'div',
        { className: 'payment-method-selector' },
        React.createElement(AccordionWidget, {
          items: items,
          onClickHeader: function onClickHeader(e, key, item) {
            return onSelectMethod({ method: item.method });
          },
          initialExpandedIndex: selectedMethodIndex
        })
      );
    }
  }]);

  return PaymentMethodSelector;
}(Component);

export default PaymentMethodSelector;